<template>
    <div>
        <magazine-write-link v-for="writeLayout in writeLayouts" :key="`magazine${writeLayout}`"
                             :categoryData="categoryData"
                             :backColor="backColor"
                             :writeLayout="writeLayout" :magazineData="magazineData"></magazine-write-link>
    </div>
</template>

<script>
import magazineUtil from "@/components/magazine/magazineUtil";
import alertMixins from "@/mixins/alertMixins";
import MagazineWriteLink from "@/components/magazine/MagazineWriteLink";
import DeleteClass from "@/mixins/deleteClass";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import MagazineValidator from "@/mixins/validators/MagazineValidator";
import ApiFileUpload from "@/mixins/ApiFileUpload";

export default {
    name: "MagazineWriteComponent",
    mixins: [alertMixins, magazineUtil, MagazineValidator, ApiFileUpload],
    components: {MagazineWriteLink},
    provide() {
        return {
            magazineWriteSetData: this.setData,
            setDeleteFittingIdx: this.setDeleteFittingIdx,
        }
    },
    props: {
        magazineType: {default: ''},
        magazineKey: {default: 0},
    },
    data() {
        return {
            getFunc: '',
            detailApiParamSet: {},
            getCategoryFunc: '',
            isCategory: true,
            writeFunc: '',
            writeLayouts: [],
            writeApiParamSet: {},
            parsingData: {},
            allSetData: false,
            fileInfo: [],
            directUrl: '',
            directType: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            writeFailMsg: '',
            fileUploadFailMsg: '',
            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',
            DeleteClass: null,
            isRunning: false,
            magazineData: {},
            categoryData: [],
            backColor: [],


            beforeEditor: [],
            deleteFittings: [],
        }
    },
    created() {
        this.initFilterConfig();
        if (this.magazineKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getMagazine();
        }
    },
    mounted() {
        EventBus.$on('writeMagazine', this.writeMagazine)
        EventBus.$on('writeDeleteMagazine', this.runDelete)
    },
    beforeDestroy() {
        EventBus.$off('writeMagazine')
        EventBus.$off('writeDeleteMagazine')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initTemplateConfig() {
            let config = this.returnMagazineConfig(this.magazineType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnMagazineConfig(this.magazineType);
            this.getFunc = config.getFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.getCategoryFunc = config.getCategoryFunc;
            this.isCategory = config.isCategory;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.parsingData = config.parsingData;
            this.allSetData = config.allSetData;
            this.fileInfo = config.fileInfo;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.writeFailMsg = config.writeFailMsg;
            this.deleteFunc = config.deleteFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.keyName = config.keyName;
            if (this.isCategory) {
                this.getCategory();
            }
            this.getBackgroundColor();
            this.newDeleteClass();
        },
        getCategory() {
            let params = {};
            try {
                this.$api.$magazine[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.categoryData = res.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        getBackgroundColor() {
            let params = {};
            try {
                this.$api.$magazine.getBackgroundColor(params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.backColor = res.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        getMagazine() {
            let params = Object.assign({}, this.detailApiParamSet);
            params.id = this.magazineKey;
            try {
                this.$api.$magazine[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type != 1 || util.isEmpty(res.List)) {
                        this.errorAlert({
                            content: '상세를 가져올 수가 없습니다.',
                        })
                        this.$router.back();
                        return false;
                    }
                    this.magazineData = res.List[0];
                    // let isFittingIng = this.checkFittingIng();
                    // if(isFittingIng) {
                    //     this.errorAlert('스마트 피팅 등록중으로 수정이 불가능합니다.')
                    // }
                    this.initTemplateConfig();
                })
            } catch (e) {
                console.log(e)
            }
        },
        checkFittingIng() {
            let isFittingIng = false;
            if(util.isEmpty(this.magazineData) || util.isEmpty(this.magazineData.Editor)) {
                return isFittingIng;
            }
            let Editor = this.magazineData.Editor;
            util.Array.each(Editor, (value, index, arr) => {
                if(!util.isEmpty(value.Recommend) && value.Recommend[0].vf_status === 0) {
                    isFittingIng = true;
                }
            })
            return isFittingIng;
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$magazine[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDelete(key, value) {
            EventBus.$emit('changeLoading', true);
            this.DeleteClass.runDelete(key, {mb_password: value,})
        },
        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.$router.back();
                }
            })
        },
        _checkValidator() {
            // let checkFittingIng = this.checkFittingIng();
            // if(checkFittingIng) {
            //     return new Promise(resolve => {
            //         this.errorAlert('스마트 피팅 등록중으로 수정이 불가능합니다.')
            //         resolve(false);
            //     })
            //     return false;
            // }
            let validatorArr = Object.keys(this.parsingData);
            return this.$validate(validatorArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success
                }
                util.Array.each(this.fileInfo, (fileInfo, index, arr) => {
                    if (success && fileInfo.required && util.isEmpty(this[fileInfo.fileName])) {
                        this.errorAlert(fileInfo.validatorMsg)
                        success = false;
                    }
                })
                return success;
            })

        },
        _makeParams() {
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                params[paramKey] = this[dataKey];
            })
            if (!util.isEmpty(params.p_reserve_date) && params.p_display === 2) {
                params.p_display = 0;
            }
            util.Array.each(params.editor, (data, index, arr) => {
                params.editor[index].pe_seq = index;
                if (data.pe_type === 2 && (data.items.length === 0 || data.items === null)) {
                    params.editor[index].pe_type = 0;
                }
                if (data.pe_type === 1 && (util.isEmpty(data.recommend) || util.isEmpty(data.recommend.items))) {
                    params.editor[index].pe_type = 0;
                    delete params.editor[index].recommend;
                }
                if(data.pe_type === 1 && data.pe_idx && data.recommend.vf_idx && this.deleteFittings.indexOf(data.recommend.vf_idx) < 0) {
                    delete params.editor[index].recommend;
                }
            });
            if (this.magazineKey != 0) {
                params[this.keyName] = this.magazineKey;
            }
            if (this.deleteEditor.length > 0) {
                util.Array.each(this.deleteEditor, (data, index, arr) => {
                    params.editor.push(data);
                })

            }

            return params
        },
        async writeMagazine() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let validator = await this._checkValidator()
            if (!validator) {
                this.isRunning = false;
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();
            try {
                this.$api.$magazine[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.Type);
                    if (type === true) {
                        let key = res.List;
                        if (this.magazineKey != 0) {
                            key = this.magazineKey;
                        }
                        this.runApiUploadFiles(this.fileInfo, key).then(res => {
                            this.afterFunc(key);
                        })
                    } else {
                        this.errorAlert(type);
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                    }
                })
            } catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },
        returnWriteType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? this.writeFailMsg : this.writeFailTypes[type]
            }
        },
        afterFunc() {
            this.isRunning = false;
            this.createAlert({
                content: '저장하였습니다.',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        EventBus.$emit('changeLoading', false)
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.deleteFittings = [];
                        this.getMagazine();
                        EventBus.$emit('changeLoading', false)
                        return false;
                    }
                    EventBus.$emit('changeLoading', false)
                    let url = this.directUrl;
                    this.$router.push(url);
                }
            })
        },
        setDeleteFittingIdx(idx) {
            if(this.deleteFittings.indexOf(idx) < 0) {
                this.deleteFittings.push(idx);
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
